


















































































































































import Vue from "vue";
import { PlayerSlotInterface } from "@/types/";
import PersistedPlayerSlotInterface from "@/types/PersistedPlayerSlotInterface";
import User from "@/User";
import { PersistedEntity } from "@/types";
import Discord from "@/Discord";
import LeadershipDialog from "@/components/arma/events/LeadershipDialog.vue";
import SlotTagChips from "./SlotTagChips.vue";
import SlotTagEditDialog from "./SlotTagEditDialog.vue";
import CommunityInterface from "@/types/CommunityInterface";

export default Vue.extend({
  components: {
    LeadershipDialog,
    SlotTagChips,
    SlotTagEditDialog,
  },
  props: {
    playerSlot: {
      required: true,
      type: Object as () => PersistedPlayerSlotInterface,
    },
    divider: {
      required: false,
      default: true,
      type: Boolean,
    },
    eventOwnerId: {
      required: false,
      type: [Number, String],
    },
    eventHasFinished: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      showLeadershipDialog: false,
      showTagEditDialog: false,
      isModerator: false,
      showCommunityDialog: false,
      dialogCommunity: null as CommunityInterface | null,
    };
  },
  async mounted() {
    this.isModerator = await User.isModerator();
  },
  computed: {
    icon(): string {
      return this.playerSlot.leader
        ? "mdi-chevron-double-up"
        : "mdi-selection-ellipse";
    },
    hasUser(): boolean {
      return !!this.playerSlot.discordUser;
    },
    hasAvatar(): boolean {
      return !!(
        this.playerSlot.discordUser && this.playerSlot.discordUser.avatar
      );
    },
    avatarSourceUri(): string {
      if (this.playerSlot.discordUser) {
        return Discord.avatarSourceUri(
          this.playerSlot.discordUser.id,
          this.playerSlot.discordUser.avatar
        );
      } else {
        return "";
      }
    },
    user() {
      return User.get();
    },
    isCurrentUser(): boolean {
      return (
        this.user !== null && this.playerSlot.discordUser!.id === this.user.id
      );
    },
    canEditTags(): boolean {
      if (this.isModerator) {
        return true;
      }
      if (this.user !== null && this.eventOwnerId && String(this.user.id) === String(this.eventOwnerId)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getRankIconUrl(filename: string): string {
      try {
        return require(`@/assets/images/icons/${filename}.svg`);
      } catch {
        return "";
      }
    },
    getEffectiveIcon(discordUser: any): any {
      const local = User.get();
      if (local && String(discordUser.id) === String(local.id)) {
        return discordUser.selectedIcon || local.selectedIcon || null;
      }
      return discordUser.selectedIcon || null;
    },
    openTagEditDialog() {
      this.showTagEditDialog = true;
    },
    handleTagsUpdated() {
      this.$emit("reload-event");
    },
    handleSignUp(playerSlot: PlayerSlotInterface & PersistedEntity) {
      if (
        playerSlot.leader &&
        localStorage.getItem("leadershipDialogDisabled") !== "true"
      ) {
        this.showLeadershipDialog = true;
      } else {
        this.signUp(playerSlot);
      }
    },
    async signUp(playerSlot: PlayerSlotInterface & PersistedEntity) {
      this.loading = true;
      const slotEndpoint = "/arma/slots/";

      const signUpData = {
        name: playerSlot.name,
        description: playerSlot.description,
        leader: playerSlot.leader,
        lottery: playerSlot.lottery,
        discordUser: playerSlot.discordUser,
      };

      await this.axios.patch(slotEndpoint + playerSlot.id, signUpData);

      this.$emit("reload-event");
      this.loading = false;
    },
    async remove(playerSlot: PlayerSlotInterface & PersistedEntity) {
      this.loading = true;
      const slotEndpoint = "/arma/slots/";
      await this.axios.delete(slotEndpoint + playerSlot.id);

      this.$emit("reload-event");
      this.loading = false;
    },
    openCommunityDialog(community: CommunityInterface) {
      this.dialogCommunity = community;
      this.showCommunityDialog = true;
    },
    effectiveCommunity(discordUser: any): CommunityInterface | null {
      const community = discordUser.community;
      if (!community || community.mainCommunity) { return null; }
      return community;
    },
  },
});
